export enum MailType {
    Activation = 'Activation',
    Reinitialisation = 'Reinitialisation',
    Deverouillage = 'Deverouillage',
    Creation = 'Creation',
}
